import "core-js/modules/esnext.global-this.js";

var globalObject = function () {
  if (typeof globalThis !== "undefined") {
    return globalThis;
  }

  if (typeof self !== "undefined") {
    return self;
  }

  return window;
}();

var FormData = globalObject.FormData,
    Blob = globalObject.Blob,
    File = globalObject.File;
export { FormData, Blob, File };